import React, {createContext, useContext, useMemo, useState} from 'react';

const noOp = (() => {
});

export const AttentionAnimation = createContext(noOp);

export function AttentionAnimationProvider({children}) {
  const [attentionHovered, setAttentionHovered] = useState(null);
  const [attentionHoveredPreviously, setAttentionHoveredPreviously] = useState(false);
  const [attentionResetKey, setAttentionResetKey] = useState(0); 

  const value = useMemo(() => ({
    attentionHovered, setAttentionHovered,
    attentionHoveredPreviously, setAttentionHoveredPreviously,
    attentionResetKey, setAttentionResetKey,
  }), [attentionHovered, attentionHoveredPreviously, attentionResetKey]);

  return (
    <AttentionAnimation.Provider value={value}>
      {children}
    </AttentionAnimation.Provider>
  )
}
